import moment from 'moment';
import {isEmpty, isNumber, isString} from 'lodash';
import {reverseShortDate} from '../common/constants/datesFormat';
import {errorFields, errorExcelFields} from './errorFields';

export const processFiles = (files) => {
  const formData = new FormData();
  files.forEach((element, index) => {
    const name = element.name;
    formData.append('file', element, name);
  });
  return formData;
};

export const validateUnique = (arr, field, value) => {
  const searchElement = arr.find((item) => item[field] === value);
  return typeof(searchElement) === 'undefined' ? true : false;
};


export const falsePrincipalPart = (arr = [], field) => {
  return arr.map((item) => ({
    ...item,
    [field]: 'N',
  }));
};


export const getTotalColumn = (arr = [], key) => {
  const total = arr.reduce((acc, value) => acc + (+value[key]), 0);
  if (total) {
    return total.toFixed(2);
  }
  return 0;
};

export const getTotalColumnPart = (arr = [], key, key2) => {
  const total = arr.reduce((acc, value) => acc + (+value[key] * +value[key2]), 0);
  if (total) {
    return total;
  }
  return 0;
};

export const parseDatesFromProcessedWarranty = (warranty = {}) => {
  const {createDate, previousDate, endDate, salesDate,
    processDate, openRepairDate, endRepairDate, repairDate} = warranty;

  const parseCreateDate = createDate ? moment(createDate) : null;
  const parsePreviousDate = previousDate ? moment(previousDate) : null;
  const parseEndDate = endDate ? moment(endDate) : null;
  const parseSalesDate = salesDate ? moment(salesDate) : null;
  const parseProcessDate = processDate ? moment(processDate) : null;
  const parseOpenRepairDate = openRepairDate ? moment(openRepairDate) : null;
  const parseEndRepairDate = endRepairDate ? moment(endRepairDate) : null;
  const parseRepairDate = repairDate ? moment(repairDate) : null;

  return {
    'createDate': parseCreateDate,
    'previousDate': parsePreviousDate,
    'endDate': parseEndDate,
    'salesDate': parseSalesDate,
    'processDate': parseProcessDate,
    'openRepairDate': parseOpenRepairDate,
    'endRepairDate': parseEndRepairDate,
    'repairDate': parseRepairDate,
  };
};

const validatePrincipalPart = ({principalPart = '', principalPartDescription = ''}) => {
  return principalPart === '' || principalPartDescription === '';
};

const validateFieldsForm = (warrantyFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);
  errorArr.forEach((errorName) => {
    let field = warrantyFields[errorName];
    // convert the number to string to validate if is empty
    field = errorName === 'campaignId' && !field ? '' : field;
    const selectField = isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });

  return error;
};


export const validateErrorsWarranty = (warranty) => {
  const {type, campaignFlag} = warranty;
  const fieldsForm = errorFields(campaignFlag);
  const validateForm = validateFieldsForm(warranty, fieldsForm);
  const errorStatus =
    warranty.stateTwc !== '08' &&
    warranty.stateTwc !== '03' &&
    warranty.stateTwc !== '10' &&
    warranty.stateTwc !== '04';

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  } else if (type !== 'VE' && !campaignFlag && validatePrincipalPart(warranty)) {
    return {
      'error': true,
      'message': 'Se requiere el ingreso de una parte principal (OFP)',
    };
  } else if (!warranty.jobs.length) {
    return {
      'error': true,
      'message': 'Se requiere el ingreso de trabajos',
    };
  } else if (warranty.invalidKm && errorStatus) {
    return {
      'error': true,
      'message': 'El valor de kilometraje es inválido',
    };
  }

  return {
    'error': false,
    'message': null,
  };
};

export const getStatusOptions = (list = [], fieldUsedLikeValue) => {
  return list.map((element) => {
    const text = element.status !== '' ? element.status.concat(' - ').concat(element.description) : element.description;
    const value = fieldUsedLikeValue === 'completeName' ? text : element[fieldUsedLikeValue];
    return {text, value};
  });
};

export const getEnglishOptions = (list = [], fieldUsedLikeValue) => {
  return list.map((element, index) => {
    const value = ((element[fieldUsedLikeValue]) || '').replace(',', '.');
    const text = value;
    return {text, value, 'key': index};
  });
};

export const getSearchOptions = (list = [], fieldUsedLikeValue) => {
  return list.map((element, index) => {
    const title = (element[fieldUsedLikeValue] || '').replace(',', '.');
    return {title, 'key': index};
  });
};

const parseNumberRawValue = (value) => {
  if (!isNaN(value) && isNumber(value)) {
    return value;
  }
  return 0;
};

const parseRawStringValue = (value) => {
  if (value) {
    if (isString(value)) {
      return value.trim().toUpperCase();
    }
    return String(value);
  }
  return '';
};

const parseRawDateValue = (value) => {
  if (value && isString(value) && value.includes('/')) {
    const date = isString(value) ? value : String(value);
    const dateString = date.trim();
    if (dateString.length < 11) {
      return moment(dateString, reverseShortDate).format(reverseShortDate);
    }
  }
  return null;
};

export const validateExcelFields = (data) => {
  let error = {
    'error': false,
    'message': null,
  };
  data.forEach((item, idx) => {
    const errorFields = errorExcelFields(item);
    const validateForm = validateFieldsForm(item, errorFields);
    if (validateForm.error) {
      error = {
        'error': true,
        'message': `En la linea ${idx + 1} el campo ${validateForm.field} es requerido`,
      };
      return error;
    }
  });
  return error;
};

export const parseWarrantiesFileData = (data) => {
  return data.map((item) => ({
    'type': 'VE',
    'dealerId': parseRawStringValue(item[1]),
    'reclaimCode': parseRawStringValue(item[2]),
    'campaignId': parseNumberRawValue(item[3]),
    'operationType': parseNumberRawValue(item[4]),
    'numTwcDealer': parseRawStringValue(item[5]),
    'numFac': parseRawStringValue(item[6]),
    'orderRepairId': parseRawStringValue(item[7]),
    'chassis': parseRawStringValue(item[8]),
    'salesDate': parseRawDateValue(item[9]),
    'km': parseNumberRawValue(item[10]),
    'repairDate': parseRawDateValue(item[11]),
    'actualDate': parseRawDateValue(item[12]),
    'principalPart': parseRawStringValue(item[13]),
    'principalPartDescription': '',
    'processDate': parseRawDateValue(item[14]),
    'openRepairDate': parseRawDateValue(item[15]),
    'endRepairDate': parseRawDateValue(item[16]),
    'condition': parseRawStringValue(item[17]),
    'cause': parseRawStringValue(item[18]),
    'repair': parseRawStringValue(item[19]),
    'taskId': parseRawStringValue(item[20]),
    'hours': parseNumberRawValue(item[21]),
    'partNo1': parseRawStringValue(item[22]),
    'quantity1': item[22] ? parseNumberRawValue(item[23]) : '',
    'partNo2': parseRawStringValue(item[24]),
    'quantity2': item[24] ? parseNumberRawValue(item[25]) : '',
    'partNo3': parseRawStringValue(item[26]),
    'quantity3': item[27] ? parseNumberRawValue(item[27]) : '',
    'partNo4': parseRawStringValue(item[28]),
    'quantity4': item[29] ? parseNumberRawValue(item[29]) : '',
    'previousDate': null,
    'previousKm': null,
    'campaignFlag': item[3] ? true : false,
    'task1': '',
    'task2': '',
    'observationTDE': '',
    'observationDealer': '',
    'numPreviousOrder': '',
    'previousNumFac': '',
    'numFacActual': '',
    'lastDate': null,
    'evidenceFlag': false,
    'tsbNo': '',
    'batteryCodeP11': '',
    'batteryCodeP12': '',
    'batteryCodeP21': '',
    'batteryCodeP22': '',
    'diagnosisCodeP1': '',
    'diagnosisCodeP2': '',
    'diagnosisCodeP3': '',
    'diagnosisCodeP4': '',
    'diagnosisCodeP5': '',
    'errorId': null,
  }));
};

export const parseTasksOptions = (tasks) => {
  return tasks.map((task) => {
    return {
      'text': task.taskId,
      'value': task.taskId,
    };
  });
};
